import Webcam from "react-webcam";
import AIImage from "../../assets/ai-brain_white.png";
import { FiAlertTriangle } from "react-icons/fi";
import { ImCheckboxChecked } from "react-icons/im";
import {Eraser} from "lucide-react"
import LoadingSpinner from "../common/LoadingSpinner";
import {
  ANSWERSTATUSENUM,
  ServerStatus,
  SubmissionStatusEnum,
} from "../../environment";
import SubmitAlert from "../../components/Dialogs/SubmitAlert";
import { IconButton, Typography } from "@mui/material";
import QuestionSaveAlert from "../../components/Dialogs/QuestionSaveAlert";
import {
  FaArrowLeft,
  FaArrowRight,
  FaTrashAlt,
  FaCheck,
  FaCheckCircle,
} from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi2";
import { FaQuestionCircle } from "react-icons/fa";

import "./OnlineExam.css";
import { ChevronLeft, ChevronRight, ZoomIn } from "lucide-react";
import ImageModalPreview from "../../components/ImageModalPreview";
import WarningModal from "../../components/Dialogs/WarningModal";
import ExamQuestionPanel from "./ExamQuestionPanel";
import ButtonPanel from "./ButtonPanel";
import ExamQuestionPanelForMobile from "./ExamQuestionPanelForMobile";

import { ReviewModeModal } from "./ReviewModal";
import Close from "@mui/icons-material/Close";
import { FC } from "react";
import useUserStore from "../../stores/useUserStores";
import UserAvatar from "../../components/UserAvatar";
import { base64ToString } from "../../utils";

type OnlineExamViewProps = {
  exam: any;
  isResumeCase: boolean;
  handlePrevious: () => void;
  videoRef: React.MutableRefObject<any>;
  setReviewCaseActivated: React.Dispatch<React.SetStateAction<boolean>>;
  reviewCaseActivated: boolean;
  isReviewCase: number;
  setAnswer: React.Dispatch<
    React.SetStateAction<{
      ans_id: number | string | null;
      section: string;
    }>
  >;
  setanswer: ({
    finalCallback,
    isFinal,
    timesUpCallback,
    status,
    skip_next
  }: {
    finalCallback?: any;
    timesUpCallback?: any;
    isFinal?: boolean;
    status?:ANSWERSTATUSENUM,
    skip_next?:boolean
  }) => void;
  setShowWarningModal: React.Dispatch<React.SetStateAction<boolean>>;
  warningModalOpen: boolean;
  setWarningModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  showWarningModal: boolean;
  cancelSubmitAction: (isReviewd?: boolean) => void;
  sendFinalResponse: () => Promise<void>;
  findOutReviewedItemAndIndex: () => void;
  isTimeOver: boolean;
  setSubmissionStateType: any;
  questionSaveAlert: number;
  setQuestionSaveAlert: React.Dispatch<React.SetStateAction<number>>;
  ignoreQuestionSaveAction: () => void;
  selectedImage: any;
  examQuestionDetails: any;
  setSelectedImage: React.Dispatch<React.SetStateAction<any>>;
  setWebCamResponse: React.Dispatch<React.SetStateAction<any>>;
  questionSavedMessage: string;
  webCamResponse: any;
  markforreview: () => void;
  currentIndex: number;
  Answers: {
    ans_id: number | string | null;
    section: string;
  };
  questionErrorMessage: string;
  timeLeft: {
    hours: string;
    minutes: string;
    seconds: string;
  };
  secondsAnimated: boolean;
  loading: any;
  clearresponse: () => void;
  reviewedIndex: number;
  reviewwdArray: number[];
  mobileControllerOpened: boolean;
  setMobileControllerOpened: React.Dispatch<React.SetStateAction<boolean>>;
  getStattusCount: (type: ANSWERSTATUSENUM) => any;
  getNotVisitCount: () => any;
  handleChangeDisplay: (questionIndex?: number) => void;
};
const OnlineExamView: FC<OnlineExamViewProps> = ({
  handlePrevious,
  mobileControllerOpened,
  setMobileControllerOpened,
  handleChangeDisplay,
  getNotVisitCount,
  getStattusCount,
  reviewwdArray,
  reviewedIndex,
  clearresponse,
  markforreview,
  isResumeCase,
  Answers,
  examQuestionDetails,
  questionSavedMessage,
  loading,
  currentIndex,
  secondsAnimated,
  timeLeft,
  webCamResponse,
  questionErrorMessage,
  setWebCamResponse,
  ignoreQuestionSaveAction,
  setSelectedImage,
  selectedImage,
  setQuestionSaveAlert,
  questionSaveAlert,
  isTimeOver,
  setSubmissionStateType,
  findOutReviewedItemAndIndex,
  cancelSubmitAction,
  sendFinalResponse,
  setWarningModalOpen,
  showWarningModal,
  warningModalOpen,
  setShowWarningModal,
  setAnswer,
  setanswer,
  setReviewCaseActivated,
  isReviewCase,
  exam,
  videoRef,
  reviewCaseActivated,
}): JSX.Element => {
  const {userdetail} = useUserStore()
  console.log("userdetail >>>>151 ",{userdetail});
  
  console.log("examQuestionDetails >>>>>>>  154",examQuestionDetails);
  
  return (
    <div className=" w-screen h-screen overflow-hidden md:p-0">
      {exam?.is_proctor_enabled && ServerStatus === "ONLINE" ? (
        <Webcam
          audio={false}
          className="fixed w-[100px] h-[80px] md:w-[160px] md:h-[100px] top-[2.5%] !md:top-[0%] !right-[0.1%] object-cover !z-[999999] sm:block rounded-md border-l-2 border-b-2 shadow-md border-white"
          height={720}
          ref={videoRef}
          screenshotFormat="image/jpeg"
          width={1280}
          videoConstraints={{
            width: 1280,
            height: 720,
            facingMode: "user",
          }}
        />
      ) : (
        <></>
      )}
      {reviewCaseActivated ? (
        <ReviewModeModal
          skippedOrMarkCount={isReviewCase}
          isOpen={reviewCaseActivated}
          onClose={() => {
            setReviewCaseActivated(false);
          }}
          onStartReview={() => {
            setReviewCaseActivated(false);
          }}
          onSubmitDirectly={() => {
            setReviewCaseActivated(false);
            setanswer({
              finalCallback: () => setShowWarningModal(true),
              isFinal: true,
            });
          }}
        />
      ) : (
        <></>
      )}

      {warningModalOpen ? (
        <WarningModal
          isOpen={warningModalOpen}
          onClose={() => setWarningModalOpen(false)}
        />
      ) : (
        <></>
      )}
      {showWarningModal ? (
        <SubmitAlert
          isOpen={showWarningModal}
          handleClose={cancelSubmitAction}
          submitAction={sendFinalResponse}
          reviewAction={findOutReviewedItemAndIndex}
          isReview={isReviewCase > 0}
          isTimeOver={isTimeOver}
          cancelAction={(isReview) => {
            cancelSubmitAction(isReview);
          }}
          timeOverCallback={() =>
            setSubmissionStateType(SubmissionStatusEnum.TIME_OUT)
          }
          submitCallback={() =>
            setSubmissionStateType(SubmissionStatusEnum.SUBMITTED)
          }
        >
          <Typography
            id="transition-modal-description"
            sx={{
              // textTransform: "capitalize",
              fontSize: "12px",
              ml: "4px",
            }}
          >
            There are
            <span className="font-bold text-lg"> {isReviewCase} </span>
            'Skipped' question(s)
          </Typography>
        </SubmitAlert>
      ) : (
        <></>
      )}
      {questionSaveAlert >= -1 ? (
        <QuestionSaveAlert
          isOpen={questionSaveAlert >= -1}
          handleClose={() => setQuestionSaveAlert(-3)}
          submitAction={ignoreQuestionSaveAction}
        />
      ) : (
        <></>
      )}

      <section>
        {!!selectedImage && selectedImage.length ? (
          <ImageModalPreview
            imageModalOpen={!!selectedImage && selectedImage.length}
            handleClose={() => {
              setSelectedImage(null);
            }}
            title={" Preview Image"}
          >
            <div className=" md:h-[395px] ">
              {!!selectedImage ? (
                <div className="p-2 h-full w-full  ">
                  <img
                    className="h-full w-full object-contain"
                    src={selectedImage}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </ImageModalPreview>
        ) : (
          <></>
        )}

        {/*  START EXAM MESSAGE  */}
        <div className="w-full py-1 pt-2 text-gray-800 flex items-center justify-center bg-yellow-300 font-semibold ">
          <FiAlertTriangle className="text-gray-800" />{" "}
          <span className="ml-3 text-xs font-semibold lg:text-sm">
            {" "}
            Do not leave or minimize the window
          </span>
        </div>

        {webCamResponse && webCamResponse?.objects_detected.length ? (
          <div
            className={`w-screen  bg-red-400 fixed  py-2 z-[300] left-0 top-0  transition-all ease-linear items-center justify-between duration-700 px-5  text-center lg:text-xl font-semibold text-white flex `}
          >
            <div className="flex  gap-x-5 px-5 ">
              <div className="z-[999] absolute top-0 left-3">
                <Close
                  className="text-white cursor-pointer"
                  onClick={() => setWebCamResponse(null)}
                />
              </div>
              <div className="ml-3">
                <img
                  src={AIImage}
                  alt="AI"
                  className="w-12 h-12 text-white object-cover hidden md:block"
                />
              </div>
              <div className="flex flex-col justify-start">
                <p className="md:mt-1  text-white md:text-lg text-md  text-start py-1">
                  {" "}
                  Unauthorized Gadget Detected (Detected Gadget :{" "}
                  {webCamResponse?.objects_detected?.join(", ")})
                </p>
                <p className=" text-white text-sm animate-pulse hidden md:block">
                  Suspicious device or gadget detected. Please remove any
                  unauthorized electronic items.
                </p>
              </div>
            </div>
          </div>
        ) : webCamResponse && webCamResponse?.multiple_faces ? (
          <div
            className={`w-screen  bg-red-400 fixed py-2  z-[400] left-0 top-0  transition-all ease-linear items-center justify-between duration-700 px-5  text-center lg:text-xl font-semibold text-white flex `}
          >
            <div className="flex  gap-x-5 px-5">
              <div className="z-[999] absolute top-0 left-3">
                <Close
                  className="text-white cursor-pointer"
                  onClick={() => setWebCamResponse(null)}
                />
              </div>
              <div className="ml-3">
                <img
                  src={AIImage}
                  alt="AI"
                  className="w-12 h-12 text-white object-cover hidden md:block"
                />
              </div>
              <div className="flex flex-col justify-start">
                <p className="md:mt-1  text-white md:text-lg text-md  text-start py-1">
                  {" "}
                  Multiple Faces Detected
                </p>
                <p className=" text-white text-sm animate-pulse md:block hidden">
                  Multiple faces detected in the camera view. This is not
                  allowed. Kindly ensure you are alone during the exam.
                </p>
              </div>
            </div>
          </div>
        ) : webCamResponse && !webCamResponse?.is_valid_user ? (
          <div
            className={`w-screen  bg-red-400 fixed  z-[500] left-0 top-0  transition-all ease-linear items-center justify-between duration-700 px-5  text-center lg:text-xl font-semibold text-white flex `}
          >
            <div className="flex  gap-x-5 px-5">
              <div className="z-[999] absolute top-0 left-3">
                <Close
                  className="text-white cursor-pointer"
                  onClick={() => setWebCamResponse(null)}
                />
              </div>
              <div className="ml-3">
                <img
                  src={AIImage}
                  alt="AI"
                  className="w-12 h-12 text-white object-cover hidden md:block"
                />
              </div>
              <div className="flex flex-col justify-start">
                <p className="md:mt-1  text-white md:text-lg text-md  text-start py-1">
                  {" "}
                  Face Not Detected
                </p>
                <p className=" text-white text-sm animate-pulse hidden md:block">
                  Your face is not clearly visible. Please adjust your position
                  to stay within the camera frame.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        <div
          className={`w-screen  bg-red-400 fixed top-0 z-10 left-0 ${
            questionErrorMessage.trim().length !== 0 ? `top-0` : `-top-[300%]`
          } transition-all ease-linear duration-700   text-center lg:text-xl font-semibold text-white`}
        >
          {questionErrorMessage.trim().length ? (
            <p className="md:my-3 my-[2px]">{questionErrorMessage} </p>
          ) : (
            <></>
          )}
        </div>
         <div className="md:h-auto h-[50px] flex justify-between items-center md:mx-[6rem] mx-1 py-2">
          <div
            className={exam?.is_proctor_enabled && ServerStatus === "ONLINE" ?  " w-full  flex items-center gap-x-10 pr-4" : " w-full  flex items-center justify-between"}
            style={{ flexShrink: 0 }}
          >
            <div className="hidden md:flex items-center border border-blue-500 px-4 md:py-[2px] rounded-lg bg-gradient-to-r from-blue-100 to-blue-50 text-blue-600  select-none  text-lg font-semibold tracking-wide shadow-sm hover:shadow-md transition-shadow duration-200">
              {exam?.title}
            </div>

            {reviewwdArray.length && !reviewCaseActivated ? (
              <div className="bg-gradient-to-r from-pink-400 to-pink-500 text-white px-4 py-1 rounded-lg font-medium shadow-lg animate-pulse">
                Review Mode Enabled
              </div>
            ) : (
              <></>
            )}
            {userdetail ? (
              <UserAvatar
                userInfo={{
                  name: userdetail.fullName,
                  email: userdetail.email,
                  center: userdetail.centerId,
                  phone: userdetail.phone,
                }}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="flex flex-col items-center gap-4  md:hidden mt-3">
            {/* Time Left Label with Modern Design */}
            <div className="flex items-center gap-3 ">
              {/* Timer */}
              <div className="flex items-center gap-3">
                {/* Hours */}
                <div className="flex flex-col items-center">
                  <div className="bg-indigo-600 rounded-lg md:w-10 md:h-10 h-9 w-9 relative">
                    <h3 className="md:text-lg text-sm  font-semibold text-white text-center mt-3">
                      {timeLeft.hours}
                    </h3>
                    <p className=" absolute top-0 left-[30%] text-[10px] text-white">
                      Hrs
                    </p>
                  </div>
                </div>
                {/* Minutes */}
                <div className="flex flex-col items-center">
                  <div className="bg-indigo-600 rounded-lg md:w-10 md:h-10 h-9 w-9 relative">
                    <h3 className="md:text-lg text-sm  font-semibold text-white text-center mt-3">
                      {timeLeft.minutes}
                    </h3>
                    <p className=" absolute top-0 left-[30%] text-[10px] text-white">
                      Min
                    </p>
                  </div>
                </div>

                {/* Seconds */}
                <div className="flex flex-col items-center">
                  <div className="bg-indigo-600 rounded-lg md:w-10 md:h-10 h-9 w-9 relative">
                    <h3
                      className={`md:text-lg text-sm font-semibold text-white text-center mt-3  ${
                        secondsAnimated ? "animate-countinsecond" : ""
                      }`}
                    >
                      {timeLeft.seconds}
                    </h3>
                    <p className=" absolute top-0 left-[30%] text-[10px] text-white">
                      Sec
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex  md:hidden mb-2 px-1 mt-2 md:mt-0 ">
          <div
            className=" px-4 md:py-[2px]  bg-gradient-to-r rounded-sm from-blue-100 to-blue-50 text-blue-600  select-none  text-sm md:text-lg font-semibold tracking-wide shadow-sm hover:shadow-md transition-shadow duration-200"
            style={{ flexShrink: 0 }}
          >
            {exam?.title}
          </div>
        </div>

        {loading ? (
          <LoadingSpinner />
        ) : (
          <div className="relative flex flex-col overflow-hidden   ">
            {/* subject section */}
            {/* question and side showbar */}
            <div className="flex h-[92vh] bg-gray-100 md:p-2">
              {/* Main Question Panel */}
              <div className="flex flex-col md:w-[75%]  w-full p-2   bg-white md:p-6 rounded-lg shadow-lg border border-gray-300 md:mr-4">
                <div className="flex justify-between items-center mb-4">
                  {/* Question Number Section */}
                  <div className="flex items-center bg-indigo-100 text-indigo-600  px-2 py-1 rounded-lg">
                    <FaQuestionCircle
                      className="text-indigo-600 mr-2"
                      size={15}
                    />
                    <span className="text-sm font-bold md:flex md:gap-x-1">
                      <span className="hidden md:block">Question</span>
                      {currentIndex + 1}
                    </span>
                  </div>
                  {questionSavedMessage.trim().length !== 0 ? (
                    <></>
                  ) : (
                    <div></div>
                  )}

                  {examQuestionDetails?.questions[currentIndex] ? (
                    <div className="flex items-center gap-x-2">
                      {examQuestionDetails?.questions[currentIndex]?.marks &&
                      Number(
                        examQuestionDetails?.questions[currentIndex]?.marks
                      ) ? (
                        <div className="flex items-center bg-green-100 text-green-700 px-3 py-1 rounded-lg">
                          <ImCheckboxChecked
                            className="text-green-500 mr-2"
                            size={15}
                          />
                          <p className="text-sm font-medium lg:flex lg:gap-x-2">
                            <span className="hidden md:block">Marks:</span>
                            <span className="font-bold ml-1">
                              {
                                examQuestionDetails?.questions[currentIndex]
                                  ?.marks
                              }
                            </span>
                          </p>
                        </div>
                      ) : (
                        <></>
                      )}
                      {/* Negative Mark Section */}
                      {examQuestionDetails?.questions[currentIndex]
                        ?.negetive_mark &&
                      Number(
                        examQuestionDetails?.questions[currentIndex]
                          ?.negetive_mark
                      ) ? (
                        <div className="flex items-center bg-red-100 text-red-700  px-2 py-1 rounded-lg">
                          <HiMinusCircle
                            className="text-red-500 mr-2"
                            size={15}
                          />
                          <p className="text-sm font-medium lg:flex lg:gap-x-2">
                            <span className="hidden md:block">
                              Negative marks:
                            </span>
                            <span className="font-bold">
                              {" "}
                              {
                                examQuestionDetails?.questions[currentIndex]
                                  ?.negetive_mark
                              }
                            </span>
                          </p>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <div className="w-[200px] h-[40px] opacity-0"></div> // Placeholder div with fixed size and hidden content
                  )}
                </div>

                {/* Scrollable Question Section */}
                <div
                  className="mb-6 overflow-y-auto max-h-[50vh]"
                  style={{
                    userSelect: "none", // disables text selection
                    WebkitUserSelect: "none",
                    MozUserSelect: "none",
                    msUserSelect: "none",
                    cursor: "default",
                  }}
                  onCopy={(event) => {
                    event.preventDefault();
                  }}
                  onContextMenu={(event) => {
                    event.preventDefault();
                  }}
                >
                  <p
                    className="text-gray-700 mb-4"
                    onCopy={(event) => {
                      event.preventDefault();
                    }}
                    onContextMenu={(event) => {
                      event.preventDefault();
                    }}
                  >
                    {examQuestionDetails &&
                    examQuestionDetails?.questions &&
                    Array.isArray(examQuestionDetails?.questions) &&
                    examQuestionDetails?.questions.length > 0 &&
                    examQuestionDetails?.questions.length > currentIndex
                      ? `${examQuestionDetails?.questions[currentIndex]?.question}`
                      : `Question not found`}
                  </p>
                  {examQuestionDetails &&
                  examQuestionDetails?.questions &&
                  Array.isArray(examQuestionDetails?.questions) &&
                  examQuestionDetails?.questions.length > 0 &&
                  examQuestionDetails?.questions.length > currentIndex &&
                  examQuestionDetails?.questions[currentIndex]?.image ? (
                    <div className="mt-2 w-full flex flex-col">
                      <div className=" flex flex-col shadow-lg w-full rounded-lg   h-[210px] p-[5px]  animate__animated animate__zoomIn">
                        <div className="p-1 w-full  h-full flex flex-col relative">
                          <img
                            className="h-[80px] w-full object-contain rounded-lg"
                            src={`${base64ToString(
                              `${examQuestionDetails?.questions[currentIndex]?.image}`
                            )}`}
                          />
                          <div className="absolute -top-[5%] right-[40%]    ">
                            <IconButton
                              onClick={() =>
                                setSelectedImage(
                                  `${base64ToString(
                                    `${examQuestionDetails?.questions[currentIndex]?.image}`
                                  )}`
                                )
                              }
                            >
                              <ZoomIn className="size-5 text-gray-500" />
                            </IconButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>

                {/* Fixed Options Section */}

                <div className="space-y-3 sticky top-0 max-h-[300px] overflow-y-auto py-2">
                  {examQuestionDetails &&
                    examQuestionDetails?.questions &&
                    Array.isArray(examQuestionDetails?.questions) &&
                    examQuestionDetails?.questions.length > 0 &&
                    examQuestionDetails?.questions.length > currentIndex &&
                    Array.isArray(
                      examQuestionDetails?.questions[currentIndex]?.options
                    ) &&
                    examQuestionDetails?.questions[currentIndex]?.options.map(
                      (item: any, index: number) => (
                        <div className="flex flex-col gap-y-2">
                          <div
                            key={index}
                            className={`flex items-center space-x-3 p-3 rounded-lg cursor-pointer ${
                              Answers.ans_id === item?.ans_id
                                ? "bg-blue-200 hover:bg-blue-300"
                                : "bg-gray-100 hover:bg-gray-200"
                            } `}
                            onClick={() => {
                              setAnswer({
                                ans_id: item?.ans_id || null,
                                section:
                                  examQuestionDetails?.questions[currentIndex]
                                    .section,
                              });
                            }}
                          >
                            <input
                              type="radio"
                              name={item?.ans_id}
                              id={`${item?.ans_id}`}
                              className="form-radio h-4 w-4"
                              checked={Answers.ans_id === item?.ans_id}
                              onChange={() => {
                                setAnswer({
                                  ans_id: item?.ans_id || null,
                                  section:
                                    examQuestionDetails?.questions[currentIndex]
                                      .section,
                                });
                              }}
                            />
                            <label
                              className="cursor-pointer text-gray-700"
                              htmlFor={item?.ans_id}
                            >
                              {/* ({ALPHABETS[index].toUpperCase()}){" "} */}
                              {item.answer_field}
                            </label>
                          </div>
                          {item?.image && item?.image?.length ? (
                            <div className="mt-2 w-full flex flex-col relative">
                              <div className=" flex flex-col  w-full rounded-lg   h-auto p-[3px]  animate__animated animate__zoomIn">
                                <div className="p-1 w-full  h-full flex flex-col">
                                  <img
                                    className="h-[55px] w-full object-contain rounded-lg"
                                    // src={item.image}
                                    src={`${base64ToString(`${item.image}`)}`}
                                  />
                                  <div className="absolute -top-[10%] right-[30%]   ">
                                    <IconButton
                                      onClick={() =>
                                        setSelectedImage(
                                          `${base64ToString(`${item.image}`)}`
                                        )
                                      }
                                    >
                                      <ZoomIn className="size-5 text-gray-500" />
                                    </IconButton>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )
                    )}
                </div>

                <div className="block md:hidden  mt-auto mb-8 ">
                  <ButtonPanel
                    exam={exam}
                    handlePrevious={handlePrevious}
                    isReviewCase={isResumeCase}
                    currentIndex={currentIndex}
                    examQuestionDetails={examQuestionDetails}
                    markforreview={markforreview}
                    Answers={Answers}
                    clearresponse={clearresponse}
                    reviewedIndex={reviewedIndex}
                    reviewwdArray={reviewwdArray}
                    setanswer={setanswer}
                    setShowWarningModal={setShowWarningModal}
                  />
                </div>

                {/* Button */}
                <div className="hidden md:flex flex-col lg:flex-row md:justify-between md:items-center md:space-y-0 space-y-3 md:space-x-2 mt-auto pb-10  py-2 mb-4 md:mb-0 md:px-4  px-1">
                  {/* Left Section (Clear, Mark for Review & Next, Submit) */}
                  <div className="flex space-x-2 ">
                    {/* Mark for Review & Next Button */}
                    {/* <button
                      className={`flex items-center px-4 py-2 text-white rounded-md bg-purple-400 hover:bg-purple-600 ${
                        (exam && isReviewCase > 0 && currentIndex >= 0) ||
                        (exam &&
                          examQuestionDetails?.questions &&
                          Array.isArray(examQuestionDetails?.questions) &&
                          currentIndex >= 0)
                          ? "visible"
                          : "invisible"
                      }`}
                      id="review"
                      onClick={markforreview}
                    >
                      <FaCheckCircle className="mr-2 hidden md:block" />
                      <span className="hidden md:block">
                        Mark for Review & Next
                      </span>
                      <span className="block md:hidden text-[12px]">
                        Review & Next
                      </span>
                      <FaArrowRight className="ml-2" />
                    </button> */}

                    {/* Clear Button */}
                    <button
                      className={`flex items-center px-4 py-2 text-white rounded-md bg-gray-400 hover:bg-gray-500 gap-x-1 ${
                        !!Answers && !!Answers?.ans_id ? "visible" : "invisible"
                      }`}
                      onClick={() => {
                        clearresponse();
                        setanswer({ status: ANSWERSTATUSENUM.SKIP });
                      }}
                    >
                      <Eraser className="size-5" />
                      Clear
                    </button>
                    {/* <button
                      className={`flex items-center px-4 py-2 text-white rounded-md bg-blue-500 hover:bg-blue-600 gap-x-1 ${
                        !Answers || !Answers?.ans_id ? "visible" : "invisible"
                      }`}
                      
                      onClick={()=>{
                        clearresponse()
                        setanswer({skip_next:true,status:ANSWERSTATUSENUM.SKIP})
                      }}
                    >
                      
                       Skip & Next
                          
                    </button> */}
                  </div>

                  {/* Middle Submit Button */}
                  <div className="">
                    <button
                      className={`flex items-center px-4 py-2 rounded-md ${
                        (exam &&
                          examQuestionDetails?.questions &&
                          Array.isArray(examQuestionDetails?.questions) &&
                          examQuestionDetails.questions.length - 1 ===
                            currentIndex) ||
                        (exam &&
                          examQuestionDetails?.questions &&
                          Array.isArray(examQuestionDetails?.questions) &&
                          examQuestionDetails.questions[
                            examQuestionDetails.questions.length - 1
                          ]?.status &&
                          [
                            ANSWERSTATUSENUM.ATTEMPT,
                            ANSWERSTATUSENUM.REVIEW,
                            ANSWERSTATUSENUM.SKIP,
                          ].includes(
                            examQuestionDetails.questions[
                              examQuestionDetails.questions.length - 1
                            ]?.status
                          ))
                          ? "bg-[#08bd80] text-white hover:bg-green-600"
                          : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                      id="submit"
                      onClick={() =>
                        setanswer({
                          finalCallback: () => setShowWarningModal(true),
                          isFinal: true,
                        })
                      }
                      disabled={
                        !(
                          (exam &&
                            examQuestionDetails?.questions &&
                            Array.isArray(examQuestionDetails?.questions) &&
                            examQuestionDetails.questions.length - 1 ===
                              currentIndex) ||
                          (exam &&
                            examQuestionDetails?.questions &&
                            Array.isArray(examQuestionDetails?.questions) &&
                            examQuestionDetails.questions[
                              examQuestionDetails.questions.length - 1
                            ]?.status &&
                            [
                              ANSWERSTATUSENUM.ATTEMPT,
                              ANSWERSTATUSENUM.REVIEW,
                              ANSWERSTATUSENUM.SKIP,
                            ].includes(
                              examQuestionDetails.questions[
                                examQuestionDetails.questions.length - 1
                              ]?.status
                            ))
                        )
                      }
                    >
                      <FaCheck className="mr-2" /> Submit
                    </button>
                  </div>

                  {/* Right Section (Previous, Save & Next) */}
                  <div className="flex justify-center md:justify-start space-x-2">
                    {/* Previous Button */}
                    <button
                      className={`flex md:items-center px-4 py-2 bg-white text-gray-600 border border-gray-500 hover:bg-gray-100 rounded-md ${
                        (isReviewCase > 0 &&
                          reviewedIndex > 0 &&
                          reviewwdArray.indexOf(currentIndex) >= 0) ||
                        currentIndex > 0
                          ? "visible"
                          : "invisible"
                      }`}
                      id="save"
                      onClick={handlePrevious}
                    >
                      <FaArrowLeft className="mr-2" /> Previous
                    </button>

                    {/* Save & Next Button */}
                    <button
                      className={`flex items-center px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600     ${
                        (isReviewCase > 0 &&
                          reviewwdArray.indexOf(currentIndex) >= 0) ||
                        (examQuestionDetails &&
                          examQuestionDetails?.questions &&
                          Array.isArray(examQuestionDetails?.questions) &&
                          examQuestionDetails.questions.length > currentIndex)
                          ? "visible"
                          : "invisible"
                      }`}
                      id="save"
                      type="button"
                      onClick={() => setanswer({})}
                    >
                      {(isReviewCase > 0 &&
                        reviewwdArray.length > 0 &&
                        reviewwdArray[reviewwdArray.length - 1] ===
                          currentIndex) ||
                      (examQuestionDetails &&
                        examQuestionDetails?.questions &&
                        Array.isArray(examQuestionDetails?.questions) &&
                        examQuestionDetails.questions.length &&
                        examQuestionDetails.questions.length - 1 ===
                          currentIndex) ? (
                        "Save"
                      ) : (
                        <>
                          <span> Save & Next</span>
                          <FaArrowRight className="ml-2" />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              {/* Question Sidebar */}
              <div className="hidden md:block md:w-1/4">
                <ExamQuestionPanel
                  timeLeft={timeLeft}
                  secondsAnimated={secondsAnimated}
                  getStattusCount={getStattusCount}
                  getNotVisitCount={getNotVisitCount}
                  examQuestionDetails={examQuestionDetails}
                  handleChangeDisplay={handleChangeDisplay}
                  currentIndex={currentIndex}
                />
              </div>
              <button
                onClick={() => setMobileControllerOpened((prev) => !prev)}
                className="absolute right-0 flex md:hidden top-[48px] z-[999]  items-center justify-center w-6 h-10 md:w-6 md:h-10 bg-blue-500 rounded-l-lg border border-l-0 border-gray-200 hover:bg-blue-300 transition-colors duration-200 shadow-sm"
              >
                {mobileControllerOpened ? (
                  <ChevronRight className="h-8 w-8 text-white" />
                ) : (
                  <ChevronLeft className="h-8 w-8 text-white" />
                )}
              </button>

              <div className="md:hidden block ">
                <ExamQuestionPanelForMobile
                  collapsed={mobileControllerOpened}
                  setCollapsed={setMobileControllerOpened}
                  timeLeft={timeLeft}
                  secondsAnimated={secondsAnimated}
                  getStattusCount={getStattusCount}
                  getNotVisitCount={getNotVisitCount}
                  examQuestionDetails={examQuestionDetails}
                  handleChangeDisplay={handleChangeDisplay}
                  currentIndex={currentIndex}
                />
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default OnlineExamView;
